// @ts-nocheck
/* eslint-disable */
/*
 * Nahradí HTML nebezpečné znaky (<>"'&) entitami.
 * @param {String} str řetězec, v jehož obsahu má být escapované HTML
 * @return {String} nový řetězec, ve kterém je escapované HTML
 */
Mapy.Util.escapeHTML = function(str) {
	return typeof str === "string" ? this.escapeTags(str.replace(/&/g, "&amp;")).replace(/"/g, "&quot;").replace(/'/g, "&#039;") : "";
};

/*
 * Nahradí entity potřebné k interpretaci HTML za jejich řídící znaky (<>"'&).
 * @param {String} str řetězec, v jehož obsahu má být odescapované HTML
 * @return {String} nový řetězec, ve kterém je odescapované HTML
 */
Mapy.Util.unescapeHTML = function(str) {
	return typeof str === "string" ? str.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&#039;/g, "'").replace(/&amp;/g, "&") : "";
};

/*
 * Nahradí HTML nebezpečné znaky (<>) entitami.
 * @param {String} str řetězec, v jehož obsahu má být escapované tagy
 * @return {String} nový řetězec, ve kterém je escapované tagy
 */
Mapy.Util.escapeTags = function(str) {
	return typeof str === "string" ? str.replace(/</g, "&lt;").replace(/>/g, "&gt;") : "";
};

/*
 * Nahradí entity potřebné k interpretaci HTML za jejich řídící znaky ('&).
 * @param {String} text řetězec, v jehož obsahu mají být entity nahrazeny
 * @return {String} nový řetězec, ve kterém jsou entity nahrazeny
 */
Mapy.Util.replaceHtmlEntities = function(text) {
	return typeof text === "string" ? text.replace(/&#039;/g, "'").replace(/&#39;/g, "'").replace(/&#038;/g, "&").replace(/&#38;/g, "&") : "";
};

/*
 * Nahradí entity znaky, které reprezentují.
 * @param {String} text řetězec, v jehož obsahu mají být entity nahrazeny
 * @return {String} nový řetězec, ve kterém jsou entity nahrazeny
 */
Mapy.Util.decodeEntities = (function() {
	// this prevents any overhead from creating the object each time
	var element = Mapy.Util.node('div');

	function decodeHTMLEntities (str) {
		if (str && typeof str === 'string') {
			// strip script/html tags
			str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
			str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
			element.innerHTML = str;
			str = element.textContent;
			element.textContent = '';
		}

		return str;
	}

	return decodeHTMLEntities;
})();

/*
 * Odstraní z řetězce českou diakritiku.
 * @param {String} str řetězec, v jehož obsahu má být odstraněna diakritika
 * @return {String} nový řetězec, ve kterém je odstraněna diakritika
 */
Mapy.Util.removeDiacritic = function(str) {
	var diacritic = ["Á","Č","Ď","Ě","É","Í","Ň","Ó","Ř","Š","Ť","Ú","Ů","Ý","Ž","á","č","ď","ě","é","í","ň","ó","ř","š","ť","ú","ů","ý","ž"];
	var chars = ["A","C","D","E","E","I","N","O","R","S","T","U","U","Y","Z","a","c","d","e","e","i","n","o","r","s","t","u","u","y","z"];
	var str2 = str;

	for (var i = 0; i < str2.length; i++) {
		var index = diacritic.indexOf(str2[i]);
		if (index > -1) {
			str2 = str2.replace((new RegExp(diacritic[index], "g")), chars[index]);
		}
	}

	return str2;
};

/**
 * Porovnani dvou retezce pomoc localeCompare.
 *
 * @return {Number} -1, 0, 1 - tradicni vraceni
 */
Mapy.Util.localeCompare = function(a, b) {
	var aLen = a.length;
	var bLen = b.length;

	for (var i = 0, max = Math.max(aLen, bLen); i < max; i++) {
		if (i >= aLen) {
			return -1;
		}
		else if (i >= bLen) {
			return 1;
		}

		var test = a[i].localeCompare(b[i]);

		if (test != 0) {
			return test;
		}
	}

	// jsou stejne
	return 0;
};
